import styles from '@mathflat/common/style'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

const {
  colors: { primary },
} = styles

export const COLOR = [
  { value: `${primary}`, id: 'BLUE' },
  { value: '#ffb300', id: 'ORANGE' },
  { value: '#ff9100', id: 'CRUSTA' },
  { value: '#f55381', id: 'PINK' },
  { value: '#3e53bb', id: 'SAPPHIRE' },
  { value: '#6ec05f', id: 'GREEN' },
  { value: '#3fa191', id: 'JUNGLE_GREEN' },
  { value: '#9d9d9d', id: 'GRAY' },
] as const

const DIVIDE_OPTION = {
  0: { label: '기본', id: 0, checked: 'check_default', uncheck: 'uncheck_default' },
  2: { label: '2분할', id: 2, checked: 'check_2', uncheck: 'uncheck_2' },
  4: { label: '4분할', id: 4, checked: 'check_4', uncheck: 'uncheck_4' },
  6: { label: '6분할', id: 6, checked: 'check_6', uncheck: 'uncheck_6' },
  8: { label: '8분할', id: 8, checked: 'check_8', uncheck: 'uncheck_8' },
  10: { label: '10분할', id: 10, checked: 'check_10', uncheck: 'uncheck_10' },
  12: { label: '12분할', id: 12, checked: 'check_12', uncheck: 'uncheck_12' },
  14: { label: '14분할', id: 14, checked: 'check_14', uncheck: 'uncheck_14' },
  16: { label: '16분할', id: 16, checked: 'check_16', uncheck: 'uncheck_16' },
} as const

export type DivideOption = (typeof DIVIDE_OPTION)[keyof typeof DIVIDE_OPTION]

export const DIVIDE = [
  DIVIDE_OPTION[0],
  DIVIDE_OPTION[2],
  DIVIDE_OPTION[4],
  DIVIDE_OPTION[6],
] as const

// 일반 학습지 만들기 분할 (디자인 템플릿 모달도 같은 목록을 쓴다)
export const WORKSHEET_DIVIDE = [...DIVIDE, DIVIDE_OPTION[8]] as const

export const ARITHMETIC_DIVIDE = [
  DIVIDE_OPTION[16],
  DIVIDE_OPTION[14],
  DIVIDE_OPTION[12],
  DIVIDE_OPTION[10],
  DIVIDE_OPTION[8],
  DIVIDE_OPTION[6],
  DIVIDE_OPTION[4],
  DIVIDE_OPTION[2],
  DIVIDE_OPTION[0],
] as const

export const ARITHMETIC_DEFAULT_PARTITION_TYPE = ARITHMETIC_DIVIDE[0].id

// 디자인 템플릿은 플로우 간 공유라 현재 플로우 목록 밖 분할값이 올 수 있다 — 표시용 전체 사전
export const ALL_DIVIDE_OPTIONS: readonly DivideOption[] = Object.values(DIVIDE_OPTION)

export const PREIVEW_IMAGE = {
  '#00ABFF': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/skyblue/design2_header_sky_blue.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/skyblue/design2_bottom_sky_blue2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/skyblue/design3_header_sky_blue.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/skyblue/design3_bottom_sky_blue2.png`,
  ],
  '#ffb300': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/yellow/design2_header_orange.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/yellow/design2_bottom_orange2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/yellow/design3_header_orange.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/yellow/design3_bottom_orange2.png`,
  ],
  '#ff9100': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/orange/design2_header_orange_dark.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/orange/design2_bottom_orange_dark2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/orange/design3_header_orange_dark.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/orange/design3_bottom_orange_dark2.png`,
  ],
  '#f55381': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/pink/design2_header_pink.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/pink/design2_bottom_pink2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/pink/design3_header_pink.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/pink/design3_bottom_pink2.png`,
  ],
  '#3e53bb': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/blue/design2_header_blue.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/blue/design2_bottom_blue2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/blue/design3_header_blue.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/blue/design3_bottom_blue2.png`,
  ],
  '#6ec05f': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/green/design2_header_green.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/green/design2_bottom_green2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/green/design3_header_green.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/green/design3_bottom_green2.png`,
  ],
  '#3fa191': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/darkgreen/design2_header_green_dark.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/darkgreen/design2_bottom_green_dark2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/darkgreen/design3_header_green_dark.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/darkgreen/design3_bottom_green_dark2.png`,
  ],
  '#9d9d9d': [
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/gray/design2_header_gray.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/gray/design2_bottom_gray2.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/gray/design3_header_gray.png`,
    `https://mathflat-assets.${domainProvider.TARGET_DOMAIN}/worksheet-preview/gray/design3_bottom_gray2.png`,
  ],
}
